import { Menu } from '@headlessui/react';
import clsx from 'clsx';
import { FC } from 'react';
import { useNavigate } from 'react-router';

interface SettingsLinkProps {
  name: string;
  to?: string;
  onClick?: () => void;
}

const SettingsLink: FC<SettingsLinkProps> = ({ name, to, onClick }) => {
  const navigate = useNavigate();

  const onButtonClick = () => {
    if (onClick) {
      onClick();
    }

    if (to) {
      navigate(to);
    }
  };
  return (
    <Menu.Item>
      {({ active }) => (
        <div
          onClick={onButtonClick}
          className={clsx(
            active && 'bg-gray-50',
            'text-primary-std flex items-center gap-3 whitespace-nowrap px-4 py-2 text-left text-sm w-full'
          )}
        >
          {name}
        </div>
      )}
    </Menu.Item>
  );
};

export default SettingsLink;
